import {Pipe, PipeTransform} from '@angular/core';
import {Region} from '../model/masterdata/Region';

@Pipe({standalone: true, name: 'regionNumberPipe'})
export class RegionNumberPipe implements PipeTransform
{
  fillValue = '0';
  numberOfDigits = 3;

  transform(region: Region): string
  {
    if (region?.number)
    {
      const valueNumber = region.number;

      const numberLength = valueNumber.toString().length;
      if (numberLength < this.numberOfDigits)
      {
        const fillCount = this.numberOfDigits - numberLength;
        let addNumber = '';
        for (let i = 0; i < fillCount; i++)
          addNumber += this.fillValue;
        return addNumber + valueNumber.toString();
      }
      else
        return valueNumber.toString();
    }
    return '';
  }
}
